import {Row, Table} from "antd";
import React, {useState} from "react";
import "../../../index.css";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import {useStore} from "../../../hooks/useStore";
import {useHistory} from "react-router-dom/cjs/react-router-dom.min";
import {useFetch} from "../../../hooks/useFetch";
import WaitingTransferTable from "./waitingTransferTable/WaitingTransferTable";

const WaitingTransfer = () => {
    const [selectedGroupKeys, setSelectedGroupKeys] = useState([]);
    const [selectedTransferKeys, setSelectedTransferKeys] = useState([]);
    const [selectedShipmentKeys, setSelectedShipmentKeys] = useState([]);
    const [pageParam, setPageParam] = useState(1);
    const [barcodeStates, setBarcodeStates] = useState({});
    const stores = useStore();
    const history = useHistory();
    const [transfersLoading, transfersData, _, __, refetch] = useFetch({
        fetchFn: stores.transferStore.transfers.bind(),
        initialCall: true
    });

    const getSelectedShipmentsWithTransfers = () => {
        const shipmentTransfers = [];

        selectedShipmentKeys.forEach(key => {
            const [groupId, transferId, shipmentId] = key.split("-");

            shipmentTransfers.push({
                transferId: transferId,
                shipmentId: shipmentId
            });
        });

        return shipmentTransfers;
    };

    const [
        createTransferReferenceLoading,
        createTransferReferenceData,
        ___,
        ____,
        createTransferReference
    ] = useFetch({
        fetchFn: stores.transferStore.createTransferReference.bind(null, {
            transferShipments: getSelectedShipmentsWithTransfers()
        }),
        initialCall: false,
        loading: true,
        callbackFunc: data => {
            if (data.transferReferenceId) {
                history.push(
                    `/transfers/transfer-rotate?id=${data.transferReferenceId}&status=created`
                );
            } else {
                history.push(`/transfers/?status=waiting`);
            }
        }
    });

    const groupRowSelection = {
        selectedRowKeys: selectedGroupKeys,
        onChange: (selectedKeys, selectedRows) => {
            setSelectedGroupKeys(selectedKeys);

            const newTransferKeys = [];
            const newShipmentKeys = [];

            selectedRows.forEach(group => {
                group.transfers.forEach(transfer => {
                    newTransferKeys.push(`${group.groupId}-${transfer.transferId}`);
                    transfer.shipments.forEach(shipment => {
                        newShipmentKeys.push(
                            `${group.groupId}-${transfer.transferId}-${shipment._id}`
                        );
                    });
                });
            });

            setSelectedTransferKeys(newTransferKeys);
            setSelectedShipmentKeys(newShipmentKeys);
        }
    };

    return (
        <div className="waiting-transfer-page">
            <Row style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                <Row>
                    <div style={{marginBottom: "20px"}}>
                        <CustomButton
                            type="primary"
                            onClick={() => createTransferReference()}
                            disabled={selectedShipmentKeys.length === 0}
                        >
                            Taslak Planlama Oluştur
                        </CustomButton>
                    </div>
                </Row>
            </Row>
            <div style={{width: "100%"}}>
                <Table
                    rowKey={record => record?.groupId}
                    rowSelection={groupRowSelection}
                    dataSource={transfersData?.transfers}
                    loading={createTransferReferenceLoading || transfersLoading}
                    className="group-table"
                    bordered
                    style={{width: "100%"}}
                    scroll={{x: "100vw"}}
                    expandable={{
                        expandedRowRender: parentRecord => (
                            <WaitingTransferTable
                                parentRecord={parentRecord}
                                selectedTransferKeys={selectedTransferKeys}
                                setSelectedTransferKeys={setSelectedTransferKeys}
                                setSelectedShipmentKeys={setSelectedShipmentKeys}
                                selectedShipmentKeys={selectedShipmentKeys}
                                barcodeStates={barcodeStates}
                                setBarcodeStates={setBarcodeStates}
                                setPageParam={setPageParam}
                                transfersData={transfersData}
                            />
                        )
                    }}
                >
                    <Table.Column
                        title="Grup Adı"
                        dataIndex="groupName"
                        key="groupName"
                        width={"200px"}
                    />
                    <Table.Column
                        title="Nereden -> Nereye"
                        dataIndex="fromTo"
                        key="fromTo"
                        width={"200px"}
                        render={(fromTo, record) => (
                            <span>
                                {record?.from?.name} -{">"} {record?.to?.name}
                            </span>
                        )}
                    />
                </Table>
            </div>
        </div>
    );
};

export default WaitingTransfer;
